"use strict";

export const appLogo = "assets/Images/LogoIcon.png";
